import SEO from '../components/SEO';
import './YogoPage.css';

const YOGO_URL =
  'https://little-stars.yogo.dk/frontend/index.html?clientWebsiteReferrerUrl=https%3A%2F%2Flittle-stars.dk%2F#/signup';

export default function BlivMedlem() {
  return (
    <main className="yogo-page">
      <SEO
        title="Bliv medlem"
        path="/bliv-medlem"
        description="Bliv medlem af Little-Stars i Randers NV. Vælg mellem medlemskaber fra 75 kr/md for 1 barn. Alle voksne inkluderet. Løbende måned + 1 måneds opsigelse."
      />
      <iframe
        src={YOGO_URL}
        title="Bliv medlem - Little-Stars"
        className="yogo-page-frame"
        allow="payment"
      />
    </main>
  );
}
